import { ChainIds } from "types"
import { EXPLORER_URLS } from "./constants"

export interface Config {
  chainId: ChainIds
  apiUrl: string
  explorerUrl: string
}

const chainId: ChainIds = ChainIds.MAINNET

const apiUrl = "/api"
const explorerUrl = EXPLORER_URLS[chainId]

export const IPCOMPLY_ENDPOINT = "https://ondo.finance/api/ipcomply"
export const WALLETSCREEN_ENDPOINT = "https://ondo.finance/api/walletscreen"

const config: Config = {
  chainId,
  apiUrl,
  explorerUrl,
}

export default config

export const PROD_FLUX_MAINNET = "https://api.goldsky.com/api/private/project_cmgqm1jvcme5a01wjgoa1at60/subgraphs/flux-ethereum-prod/live/gn"
